module.exports = __webpack_public_path__ + "static/gray_slaad-b71bea26f02c1ecb3be1502e0f9791aa.jpeg";